import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../support/classnames';
import {Employee} from '../../models/employee';
import {Availability} from '../../models/availability';

interface OwnProps {
    availability: Availability;
}

export const AvailabilityIndicator: FunctionComponent<OwnProps> = ({availability}) => {
    return (
        <div className="availability-blocks">
            <div
                className={classNames(
                    'availability-block monday-morning ',
                    availability.monday_morning === 1 ? 'available' : 'unavailable',
                )}
            />
            <div
                className={classNames(
                    'availability-block tuesday-morning ',
                    availability.tuesday_morning === 1 ? 'available' : 'unavailable',
                )}
            />
            <div
                className={classNames(
                    'availability-block wednesday-morning ',
                    availability.wednesday_morning === 1 ? 'available' : 'unavailable',
                )}
            />
            <div
                className={classNames(
                    'availability-block thursday-morning ',
                    availability.thursday_morning === 1 ? 'available' : 'unavailable',
                )}
            />
            <div
                className={classNames(
                    'availability-block friday-morning ',
                    availability.friday_morning === 1 ? 'available' : 'unavailable',
                )}
            />
            <div
                className={classNames(
                    'availability-block monday ',
                    availability.monday === 1 ? 'available' : 'unavailable',
                )}
            />
            <div
                className={classNames(
                    'availability-block tuesday ',
                    availability.tuesday === 1 ? 'available' : 'unavailable',
                )}
            />
            <div
                className={classNames(
                    'availability-block wednesday ',
                    availability.wednesday === 1 ? 'available' : 'unavailable',
                )}
            />
            <div
                className={classNames(
                    'availability-block thursday ',
                    availability.thursday === 1 ? 'available' : 'unavailable',
                )}
            />
            <div
                className={classNames(
                    'availability-block friday ',
                    availability.friday === 1 ? 'available' : 'unavailable',
                )}
            />
        </div>
    );
};
